import { useState, useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';
import { deepEqual } from './deepEqual';

/**
 * @param {object} options
 * @param {string} options.TypeOfPortal     – e.g. "Edit" | "Add" | …
 * @param {object|null} options.initial      snapshot from API
 * @param {object} options.current           your live form data
 * @returns {{ isDisabled: boolean }}        object containing disable flag
 */
export default function useIsDisabled({ TypeOfPortal, initial, current }) {
  // store the very first API-loaded snapshot
  const initialRef = useRef(initial);
  const [isDisabled, setIsDisabled] = useState(true);

  // on initial load in Edit mode, lock in the snapshot
  useEffect(() => {
    if (TypeOfPortal === 'Edit' && initial != null) {
      initialRef.current = initial;
    }
  }, [TypeOfPortal, initial]);


  // whenever TypeOfPortal or current form data changes, recalc
  useEffect(() => {
    if (TypeOfPortal !== 'Edit' || initialRef.current == null) {
      // if not editing, always enable Save
      setIsDisabled(false);
    } else {
      // deep compare snapshot vs current
      setIsDisabled(deepEqual(initialRef.current, current));
    }
  }, [TypeOfPortal, current]);

  return { isDisabled };
}
